import { SingleQuizQuestion } from '@renderer/@types/types'
import { useQuiz } from '@renderer/lib/useQuiz'
import { useEffect, useMemo, useState } from 'react'
import AnswerOption from './AnswerOption'

const AnswersOptions = () => {
  const { currentIndex, currentQuestion } = useQuiz()

  const data = currentQuestion as SingleQuizQuestion

  const gridColumns = useMemo(() => {
    const count = data.options.length
    if (count === 2) return 2
    if (count === 3) return 3
    if (count === 4) return 2
    return Math.min(3, count)
  }, [data.options.length])

  const [options, setOptions] = useState(data.options)

  useEffect(() => {
    setOptions(data.options)
  }, [currentIndex])

  return (
    <div
      className="grid w-full gap-4 [@media(max-height:1100px)]:gap-2 [@media(min-height:1101px)]:gap-6"
      style={{
        gridTemplateColumns: `repeat(${gridColumns}, 1fr)`
      }}
    >
      {options.map((o) => (
        <AnswerOption data={o} key={`question-${currentIndex}-option-${o.id}`} />
      ))}
    </div>
  )
}

export default AnswersOptions
